import { render, staticRenderFns } from "./MJoinDetail.vue?vue&type=template&id=e83ef262&"
import script from "./MJoinDetail.vue?vue&type=script&lang=js&"
export * from "./MJoinDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports